let baseUrl = "/"; // 'http://121.199.62.174:52891/'

const VERSION = process.APP_VARIABLES.VERSION;

let config = {
  VERSION,
  BASE_URL: baseUrl,
  API_URL: `${baseUrl}api/`,
  SYSTEM_TITLE: "台席服务呼叫平台",
  SYSTEM_SUB_TITLE: "智慧养老信息平台"
};
export default config;
